module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_cocacola_02.a8e84977.jpg";